import { useCallback, useEffect, useRef } from 'react';

const DEFAULT_MAX_HEIGHT_PX = 200;

// Grows a textarea to fit its content up to a max height, then scrolls.
// `value` drives the re-measure so controlled updates (including programmatic
// ones) stay in sync.
export const useAutoResizeTextarea = (
  value: string | undefined,
  maxHeightPx = DEFAULT_MAX_HEIGHT_PX,
) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const resize = useCallback(() => {
    const el = textareaRef.current;
    if (el == null) {
      return;
    }
    el.style.overflow = 'hidden';
    el.style.height = '0';
    const newHeight = Math.min(el.scrollHeight, maxHeightPx);
    el.style.height = `${newHeight}px`;
    el.style.overflow = newHeight >= maxHeightPx ? 'auto' : 'hidden';
  }, [maxHeightPx]);

  useEffect(() => {
    resize();
  }, [value, resize]);

  return { textareaRef, resize };
};
